<template>

<div class="product-add">
  <el-form size="small" ref="form" :model="formData" label-width="150px">
    <div class="common-form">图标设置</div>


    <el-form-item label="对单大厅图标" prop="recycle_consignment_icon.file_id" :rules="[{ required: true, message: '请上传回收寄卖图标', trigger: 'change' }]">
      <el-button type="primary" @click="isupload=true;type='recycle_consignment_icon'">选择图片</el-button>
      <div v-if="formData.recycle_consignment_icon.file_id" class="img">
        <img :src="formData.recycle_consignment_icon.file_path" width="100" height="100" />
      </div>
    </el-form-item>
    <el-form-item label="本地生活图标" prop="pawn_sale_icon.file_id" :rules="[{ required: true, message: '请上传绝当销售图标', trigger: 'change' }]">
      <el-button type="primary" @click="isupload=true;type='pawn_sale_icon'">选择图片</el-button>
      <div v-if="formData.pawn_sale_icon.file_id" class="img">
        <img :src="formData.pawn_sale_icon.file_path" width="100" height="100" />
      </div>
    </el-form-item>

<!--    <el-form-item label="租赁服务图标" prop="lease_service_icon.file_id" :rules="[{ required: true, message: '请上传租赁服务图标', trigger: 'change' }]">-->
<!--      <el-button type="primary" @click="isupload=true;type='lease_service_icon'">选择图片</el-button>-->
<!--      <div v-if="formData.lease_service_icon.file_id" class="img">-->
<!--        <img :src="formData.lease_service_icon.file_path" width="100" height="100" />-->
<!--      </div>-->
<!--    </el-form-item>-->

<!--    <el-form-item label="商品置换图标" prop="goods_exchange_icon.file_id" :rules="[{ required: true, message: '请上传商品置换图标', trigger: 'change' }]">-->
<!--      <el-button type="primary" @click="isupload=true;type='goods_exchange_icon'">选择图片</el-button>-->
<!--      <div v-if="formData.goods_exchange_icon.file_id" class="img">-->
<!--        <img :src="formData.goods_exchange_icon.file_path" width="100" height="100" />-->
<!--      </div>-->
<!--    </el-form-item>-->

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
    </div>

  </el-form>

  <Upload v-if="isupload" :isupload="isupload" @returnImgs="uploadChange">上传图片</Upload>

</div>

</template>

<script>
import Upload from '@/components/file/Upload';
import SettingApi from '@/api/setting.js';
export default {
  components:{Upload},
  data() {
    return {
      isupload:false,
      formData: {
        recycle_consignment_icon:{},
        pawn_sale_icon:{},
        lease_service_icon:{},
        goods_exchange_icon:{},
      },
      type:'',
      loading: false,
    };
  },
  created() {
    SettingApi.getShopIconIndex().then(result=>{
      let data=result.data.vars.values;
      for(let i in this.formData){
        this.formData[i]=data[i];
      }
    })
  },

  methods: {

    onSubmit(){
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          SettingApi.setShopIconIndex(this.formData).then(result => {
            this.$message({
              message: '设置成功',
              type: 'success'
            });
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },

    // 图片上传
    uploadChange(e){
      if(e&&e!=''){
        this.formData[this.type]=e[0];
      }
      this.isupload=false
    },

  }

};
</script>

<style>
.img {
 padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/shopicon/index.vue